import {request} from '@/helpers/apiClient';
import {ACTIVITY_CONFIG} from '@/utils/constants/apiConfig/activityConfig';

export const handleCreateActivity = async (req_param) => {
  return await request(ACTIVITY_CONFIG.ACTIVITIES, req_param);
};

export const handleUpdateActivity = async (req_param) => {
  return await request(ACTIVITY_CONFIG.UPDATE_ACTIVITY, req_param);
};

export const handleGetActivity = async (queryParams, body) => {
  const payload = body ? {data: body} : '';
  return await request(ACTIVITY_CONFIG.GET_ACTIVITY, payload, queryParams);
};
export const getActivityCsvFile = (queryParams, body) =>
  request(ACTIVITY_CONFIG.ACTIVITY_CSV_DOWNLOAD(queryParams), {data: body});

export const getActivityReportFile = (activityId) =>
  request(ACTIVITY_CONFIG.ACTIVITY_REPORT_DOWNLOAD(activityId));

export const handleSaveDraftActivity = async (req_param) => {
  return await request(ACTIVITY_CONFIG.SAVE_DRAFT_ACTIVITY, req_param);
};

export const handleUpdateDraftActivity = async (req_param) => {
  return await request(ACTIVITY_CONFIG.UPDATE_DRAFT_ACTIVITY, req_param);
};

export const validateActivityName = (queryParams) =>
  request(ACTIVITY_CONFIG.VALIDATE_ACTIVITY_NAME, '', queryParams);

export const validateActivityDuration = async (req_param) => {
  return await request(ACTIVITY_CONFIG.ACTIVITY_DURATION_VALIDATION, {
    data: req_param
  });
};

export const getActivityHistory = async (queryParams = {}) => {
  return await request(ACTIVITY_CONFIG.ACTIVITY_HISTORY, '', queryParams);
};

export const searchPhoneNumber = async (queryParams = {}) => {
  return await request(ACTIVITY_CONFIG.SEARCH_PHONE_NUMBER, '', queryParams);
};

export const patchActivityStatus = (id, reqObj) =>
  request(ACTIVITY_CONFIG.PATCH_ACTIVITY_STATUS(id), {data: reqObj});

export const getFreeKickGames = async (queryParams = {}) => {
  const body = {
    activityType: 'GAME_FREE_KICK'
  };
  return await request(ACTIVITY_CONFIG.GET_ACTIVITY, {data: body}, queryParams);
};
